<template>
	<section class="dynamic-link">
		<PageHeader />
		<div class="dynamic-link__link-value-wrapper">
			<Selector
				v-model="linkType"
				:optionList="linkTypeList"
				valueKey="id"
				class="dynamic-link__link-selector"
			/>
			<b
				v-if="checkLinkValue"
				class="font-red dynamic-link__value-desc"
				v-text="'링크값 필수'"
			/>
			<input
				v-if="checkLinkValue"
				v-model="linkValue"
				type="text"
				placeholder="링크값를 입력해주세요."
				class="dynamic-link__value"
			/>
		</div>
		<div class="dynamic-link__parsed-link-wrapper">
			<b
				class="dynamic-link__parsed-link-label"
				v-text="'다이나믹 링크'"
			/>
			<input
				:value="dynamicLink"
				type="text"
				readonly
				class="dynamic-link__parsed-link"
			/>
			<input
				value="복사"
				type="button"
				:disabled="!dynamicLink"
				class="btn btn-main blue dynamic-link__parsed-link-copy-btn"
				v-clipboard:copy="dynamicLink"
			/>
		</div>
		<div class="dynamic-link__parsed-link-wrapper">
			<b class="dynamic-link__parsed-link-label" v-text="'짧은 링크'" />
			<input
				:value="shortUrl"
				type="text"
				readonly
				class="dynamic-link__parsed-link"
			/>
			<button
				type="button"
				:disabled="!dynamicLink"
				class="btn btn-main blue dynamic-link__parsed-link-copy-btn dynamic-link__parsed-link-short-btn"
				v-text="'짧은 링크 생성'"
				@click="getShortUrl"
			/>
			<input
				value="복사"
				:disabled="!shortUrl"
				type="button"
				class="btn btn-main blue dynamic-link__parsed-link-copy-btn"
				v-clipboard:copy="shortUrl"
			/>
		</div>
	</section>
</template>
<script>
	import { getShortUrl } from '@/util.js';
	import debounce from 'lodash/debounce';
	import { mapGetters } from 'vuex';
	import { isLinkValueRequired } from '@/util.js';
	import PageHeader from '@/components/PageHeader.vue';
	import Selector from '@/components/Selector.vue';

	export default {
		name: 'DynamicLink',
		components: {
			PageHeader,
			Selector,
		},
		data() {
			return {
				linkType: null,
				linkValue: '',
				dynamicLink: '',
				shortUrl: '',
			};
		},
		computed: {
			...mapGetters({
				getListAddNull: 'getListAddNull',
			}),
			linkTypeList() {
				return this.getListAddNull('newLinkType');
			},
			checkLinkValue() {
				return this.linkType
					? isLinkValueRequired(this.linkType)
					: false;
			},
		},
		methods: {
			getDynamicLink: debounce(function () {
				if (!this.linkType) {
					this.dynamicLink = '';
					return;
				}
				const linkValue = this.linkValue
					? `&value=${this.linkValue}`
					: '';
				this.dynamicLink = `${this.$store.state.env.glowpickDomain}/dynamic-link?type=${this.linkType}${linkValue}`;
			}, 700),
			async getShortUrl() {
				try {
					this.shortUrl = await getShortUrl(this.dynamicLink);
				} catch (err) {
					console.error(err);
					alert('url 생성하는데 실패했습니다.');
				}
			},
		},
		watch: {
			linkType() {
				this.linkValue = '';
				this.getDynamicLink();
			},
			linkValue() {
				this.getDynamicLink();
			},
			dynamicLink() {
				this.shortUrl = '';
			},
		},
	};
</script>
<style lang="scss" scoped>
	.dynamic-link {
		margin-top: 24px;

		&__link-value-wrapper {
			display: flex;
			align-items: center;
			justify-content: flex-start;
		}

		&__link-selector,
		&__value-desc {
			flex-shrink: 0;
		}

		&__value-desc {
			margin-left: 12px;
		}

		&__value {
			width: 100%;
			margin-left: 12px;
		}

		&__parsed-link-wrapper {
			margin-top: 24px;
			display: flex;
			align-items: center;
			justify-content: flex-start;
		}

		&__parsed-link-label {
			width: 100px;
			flex-shrink: 0;
		}

		&__parsed-link {
			width: 100%;
			margin-left: 12px;
		}

		&__parsed-link-copy-btn {
			width: 130px;
			margin-left: 24px;
			flex-shrink: 0;
		}

		&__parsed-link-short-btn {
			margin-right: 0;
		}
	}
</style>
